// Alertes techniques de l'agent (serveur d'IA figé ou hors service, passerelle injoignable, file des échecs) en bandeau
// sur toutes les pages : le 27/10, Chronix est resté figé des heures sans que personne ne le voie (alerte seulement dans
// le panneau de l'agent). autopilot-api ne les renvoie qu'au super-administrateur ; rien n'est affiché sinon.
import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { AUTOPILOT_TOKEN_KEY } from '../../../services/autopilotAuthApi';
import { AgentAlert, loadAgentAlerts } from './AgentAlerts';
import { FONT, NEUTRAL } from '../../shared/ui';

const POLL_MS = 120_000;

const hasSession = (): boolean => {
    try {
        return !!localStorage.getItem(AUTOPILOT_TOKEN_KEY);
    } catch {
        return false;
    }
};

const TechAlertsBanner: React.FC<{ load?: typeof loadAgentAlerts }> = ({ load = loadAgentAlerts }) => {
    const [alerts, setAlerts] = React.useState<AgentAlert[]>([]);
    const [hidden, setHidden] = React.useState<string>('');          // alertes masquées (jusqu'à un changement)
    React.useEffect(() => {
        let alive = true;
        const read = () => {
            if (!hasSession()) return;
            load().then((a) => { if (alive) setAlerts(a.filter((x) => !x.campaign_id)); });
        };
        read();
        const id = window.setInterval(read, POLL_MS);
        return () => { alive = false; window.clearInterval(id); };
    }, [load]);
    const signature = alerts.map((a) => a.key).join('|');
    if (!alerts.length || hidden === signature) return null;
    const critical = alerts.some((a) => a.level === 'critique');
    return (
        <Box role="alert" data-testid="tech-alerts-banner" sx={{
            position: 'fixed', top: 0, left: 0, right: 0, zIndex: 2000, display: 'flex', alignItems: 'flex-start', gap: 1.5,
            px: 2, py: 1, backgroundColor: critical ? '#FDECEA' : '#FFF4E0',
            borderBottom: `1px solid ${critical ? 'rgba(194,65,12,0.45)' : 'rgba(201,138,11,0.45)'}`,
            boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
        }}>
            <Box sx={{ flex: 1, minWidth: 0 }}>
                {alerts.map((a) => (
                    <Typography key={a.key} sx={{ fontSize: 13, fontFamily: FONT, color: a.level === 'critique' ? NEUTRAL.danger : NEUTRAL.text }}>
                        <b>{a.title}</b>{a.detail ? ` : ${a.detail}` : ''}
                    </Typography>
                ))}
            </Box>
            <IconButton size="small" aria-label="Masquer les alertes" onClick={() => setHidden(signature)}>
                <CloseRoundedIcon fontSize="small" />
            </IconButton>
        </Box>
    );
};

export default TechAlertsBanner;
